import { TActions } from '../../../AppModulesWrapper';

import { SAVE_DRAFT_START } from '../../actions/draft';
import { CHANGE_MULTI_POSTING_ENABLED, SET_OFFER } from '../../actions/offer';
import { PUBLISH_OFFER_START } from '../../actions/publishInfo';
import { RESET_STATE } from '../../actions/resetState';
import { EOfferStatus, IOfferState } from '../../types/reducers/offer';
import { offerDefaultState } from './constants';

export function offer(state: IOfferState, action: TActions) {
  switch (action.type) {
    case SET_OFFER: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case SAVE_DRAFT_START:
      return {
        ...state,
        status: EOfferStatus.draft,
      };

    case PUBLISH_OFFER_START:
      return {
        ...state,
        status: EOfferStatus.published,
      };

    case CHANGE_MULTI_POSTING_ENABLED:
      return {
        ...state,
        multiposting: {
          enabled: action.payload,
        },
      };

    case RESET_STATE:
      return {
        ...offerDefaultState,
      } as IOfferState;

    default:
      return state || offerDefaultState;
  }
}
